<template>
    <div class="box">
        <div v-if="contentShow"
             v-for="(item,index) in getAccountBindList.list" 
             :key="index" class="shop_list">
            <div class="shop_title">
                <div>
                    <i class="iconfont icon-fuhao-shangdian"></i>
                    <span class="shop_title_text">{{item.visitor_nick}}</span>
                </div>
                <p v-if='item.is_boss==1' class='Unbind' @click="UnbindBtn(index)">解绑店铺</p>
            </div>
            <div class="shop_info">
                <div class="info_left">微信昵称</div>
                <div @click="jump_WeChat(index)" class="info_right">
                    <span class="info_text">{{item.nickname}}</span>
                    <i class="iconfont icon-xiangyou"></i>
                </div>
            </div>
            <div class="shop_info" v-if="item.is_boss==1">
                <div class="info_left">手机号</div>
                <div @click="jump_phoen(index)" class="info_right">
                    <span class="info_text" :style="{color: item.mobile?'':'red'}">{{item.mobile||'立即绑定'}}</span>
                    <i class="iconfont icon-xiangyou"></i>
                </div>
            </div>
            <div class="shop_info">
                <div class="info_left">店铺角色</div>
                <div class="info_right">
                    <span class="info_text">{{item.role_name}}</span>
                </div>
            </div>
        </div>
        
        <p class="lostTest" v-if="!getAccountBindList || lostShow">暂无数据</p>
        <div class="attentionPopup" v-if='attentionPopupShow'>
            <div class="popupItem">
                <i class="iconfont icon-jinggao1"></i>
                <p class="titleText">解绑后将不能接收</p>
                <p class="titleText">该店铺旺旺上的任何消息提醒</p>
                <div class='footerDiv'>
                     <div @click='noBtn'>
                         再想想
                     </div>
                     <div @click='confirmBtn'>
                         确认
                     </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Toast } from 'vant';
import { mapState } from 'vuex';
export default {
    name:"BuildAccount",
    data() {
        return {
            attentionPopupShow: false,
            stroeIndex: '',
            contentShow: false,
            lostShow: false,
        }
    },
    computed:{
        ...mapState({
            getAccountBindList: (state)=>{
                return state.BuildAccount.GetAccountBindList
            }
        })
    },
    methods:{
        jump_phoen(index){
            let data = this.getAccountBindList.list[index]
            this.set_page_record(data.id)
            sessionStorage.setItem('Phone_Account_ID',data.id)
            if( data.mobile ){
                this.$router.push({ path:'ShowPhone', query:{mobile:data.mobile}})
            }else{
                this.$router.push({ path:'BuildPhone', query:{page_from:'change_mobile'}})
            }
        },
        jump_WeChat(index){
            let data = this.getAccountBindList.list[index]
            this.set_page_record(data.id)
            sessionStorage.setItem('WeChat_Account_ID',data.id)
            this.$router.push({ path:'ShowWeChat', query:{nickname: data.nickname}})
        },
        set_page_record(data){ // 用于设置埋点参数
            sessionStorage.setItem('page_record_receiver_id',data)
        },
        UnbindBtn(index) {
            this.attentionPopupShow = true
            this.stroeIndex = this.getAccountBindList.list[index].visitor_id
            let data = {
                page_from:'main_page',
                page_name:'BuildAccount',
                btn_name: 'UnbindBtn',
                page_time:'0.00',
                receiver_id: '',
                page_param:{},
                
            };
            this.$store.dispatch('Public/inH5Record', data)
        },
        noBtn() {
            this.attentionPopupShow = false
        },
        confirmBtn() {
            this.$store.dispatch('BuildAccount/unbindShop',{visitor_id: this.stroeIndex}).then(res=> {
                if(res.code == 1000) {
                    Toast('解绑成功')
                    this.attentionPopupShow = false
                    this.getData()
                }else if(res.code == 4002) {
                    Toast('店铺不存在')
                }else if(res.code !== 5013) {
                    Toast(res.message)
                }
            })
            
        },
        getData() {
            this.$store.dispatch('BuildAccount/GetAccountBindList',{}).then(res=>{
                if(res.code !== 1000 && res.code !== 5013){
                    Toast(res.message)
                }
                if(this.getAccountBindList.list && this.getAccountBindList.list.length>0) {
                    this.contentShow = true
                    this.lostShow = false
                }else {
                    this.contentShow = false
                    this.lostShow = true
                }
            })
        }
    },
    mounted(){
        this.$store.dispatch('BuildAccount/GetAccountBindList',{is_link:new URLSearchParams(window.location.search).get('is_link')==1}).then(res=>{
            if(res.code !== 1000 && res.code !== 5013){
                Toast(res.message)
            }
            if(this.getAccountBindList.list && this.getAccountBindList.list.length>0) {
                this.contentShow = true
                this.lostShow = false
            }else {
                this.contentShow = false
                this.lostShow = true
            }
        })
    },
}
</script>
<style lang="scss" scoped>
    @import './index.scss';
</style>